import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { ApiResponse } from 'shared/interfaces/offset-tags';
import { TOffsetTag } from '@global-types/index';
import { useTranslation } from 'react-i18next';

// I18n

export const getOffsetTags = (): Promise<ApiResponse> => {
	return apiClient.get('/offset_tags', {
		params: {
			pageSize: 100,
		},
	});
};

export const useOffsetTags = () => {
	const { i18n } = useTranslation();

	const { data, isFetching, isFetched } = useQuery({
		queryKey: ['offset-tags'],
		queryFn: () => getOffsetTags(),
	});

	const updateList = (offsetTags: TOffsetTag[]) =>
		offsetTags && Array.isArray(offsetTags)
			? offsetTags.reduce(
					(
						acc: Partial<TOffsetTag>[],
						currentItem: TOffsetTag
					) => {
						const modifiedItem = {
							id: currentItem.id,
							color: currentItem.color,
							label:
								i18n.language == 'en'
									? currentItem.value.en
									: currentItem.value.fr,
						};
						acc.push(modifiedItem);
						return acc;
					},
					[]
				)
			: [];

	return {
		data: data ? updateList(data?.rows) : [],
		isLoading: isFetching && !isFetched,
		isFetched,
		total: data?.total,
		page: data?.page,
		pageSize: data?.pageSize,
		totalPages: data?.totalPages,
	};
};
